function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavDashboard = function SvgNavDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,0H12.5C5.61,0,0,5.61,0,12.5v41.67c0,6.89,5.61,12.5,12.5,12.5h66.67c6.89,0,12.5-5.61,12.5-12.5V12.5c0-6.89-5.61-12.5-12.5-12.5ZM83.33,54.17c0,2.3-1.88,4.17-4.17,4.17H12.5c-2.29,0-4.17-1.87-4.17-4.17V12.5c0-2.3,1.88-4.17,4.17-4.17h66.67c2.29,0,4.17,1.87,4.17,4.17v41.67Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,83.33H12.5c-6.89,0-12.5,5.61-12.5,12.5v91.67c0,6.89,5.61,12.5,12.5,12.5h66.67c6.89,0,12.5-5.61,12.5-12.5v-91.67c0-6.89-5.61-12.5-12.5-12.5ZM83.33,187.5c0,2.3-1.88,4.17-4.17,4.17H12.5c-2.29,0-4.17-1.87-4.17-4.17v-91.67c0-2.3,1.88-4.17,4.17-4.17h66.67c2.29,0,4.17,1.87,4.17,4.17v91.67Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,133.33h-66.67c-6.89,0-12.5,5.61-12.5,12.5v41.67c0,6.89,5.61,12.5,12.5,12.5h66.67c6.89,0,12.5-5.61,12.5-12.5v-41.67c0-6.89-5.61-12.5-12.5-12.5ZM191.67,187.5c0,2.3-1.88,4.17-4.17,4.17h-66.67c-2.29,0-4.17-1.87-4.17-4.17v-41.67c0-2.3,1.88-4.17,4.17-4.17h66.67c2.29,0,4.17,1.87,4.17,4.17v41.67Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.33,
    width: 91.67,
    height: 116.67,
    rx: 12.5,
    ry: 12.5,
    style: {
      fill: "#e3f9ff",
      strokeWidth: 0
    }
  }));
};
export default SvgNavDashboard;